module.exports = __webpack_public_path__ + "img/header-diamondJewelryWhitegold.12d9678.jpg";